import { h } from '../lib/dom.js';
import { getState, setSilent } from '../store.js';
import { cancelImportKey, saveImportKey, validateImportPhraseBlur } from '../actions.js';
import { t } from '../i18n/index.js';

export function renderImportKeyModal() {
  const s = getState();
  if (!s.showImportKey) return null;
  return h('div', { class: 'modal-scrim' }, [
    h('div', { class: 'modal-card' }, [
      h('div', { class: 'modal-title' }, t('modals.importKey.title')),
      h('textarea', {
        placeholder: t('modals.importKey.phrasePlaceholder'), class: 'mono textarea-tall',
        oninput: (e) => setSilent({ importText: e.target.value }),
        onblur: validateImportPhraseBlur
      }, s.importText),
      h('div', { class: 'field-error' }, s.importError || ''),
      h('div', { class: 'btn-row' }, [
        h('button', { class: 'btn btn-secondary', onclick: cancelImportKey }, t('common.cancel')),
        h('button', { class: 'btn btn-primary', onclick: saveImportKey }, t('modals.importKey.import'))
      ])
    ])
  ]);
}
